import { countries, formatShortDate, regions } from "../../../../Utils/Utils";
import useApi from "../../../../Utils/BackendClient";
import { useState, useContext, useEffect, useRef, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useIsMobile } from "../../../../Utils/ResizeUtils";

import CalendarInput from "../../../UIElements/Inputs/CalendarInput";
import CheckboxInput from "../../../UIElements/Inputs/CheckboxInput";
import CommonToolbar from "../../../UIElements/CommonToolbar";
import DropdownInput from "../../../UIElements/Inputs/DropdownInput";
import EnumsContext from "../../../../context/enums-context";
import HistoryElement from "../../../UIElements/HistoryElement";
import RadioButtonInput from "../../../UIElements/Inputs/RadioButtonInput";
import TextInput from "../../../UIElements/Inputs/TextInput";
import useGetEnums from "../../../../Utils/EnumsUtils";

import { Button } from "primereact/button";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { TabMenu } from "primereact/tabmenu";
import { Toast } from "primereact/toast";

import commonStyle from '../../CommonStyles.module.css';
import { DisplayErrors } from "../../../../Utils/ErrorHandler";

const NewCounterAgent = () => {

    const ctx = useContext(EnumsContext);
    const isMobile = useIsMobile();
    const location = useLocation();
    const navigate = useNavigate();
    const toast = useRef(null);

    const { createCagent, fetchCagentDetails, fetchCagentHistory, updateCagent } = useApi();

    const [cagentData, setCagentData] = useState({
        type: "INDIVIDUAL",
        division: null,
        phone: "",
        email: "",
        is_partner: !location.state.isClient,
        is_client: location.state.isClient,
        country: "UKRAINE",
        region: null,
        city: "",
        street: "",
        building_number: "",
        apartment_number: "",
        notes: "",
        individual_cagent_data: {
            first_name: "",
            last_name: "",
            surname: "",
            date_of_birth: null
        },
        legal_cagent_data: {
            long_name: "",
            short_name: "",
            representative: "",
            edrpou: ""
        },
        cagent_financial_data: []
    });
    const [cagentHistory, setCagentHistory] = useState(null);
    const [historyLazyState, setHistoryLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1
    });
    const [historyTotalRecords, setHistoryTotalRecords] = useState(0);
    const [isEdit, setIsEdit] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [tabShowed, setTabShowed] = useState(0);

    const enumTypes = useMemo(() => ["divisions"], []);

    useGetEnums(enumTypes);

    const items = [
        {
            label: 'Адреса',
            icon: 'pi pi-home',
            command: () => {
                setTabShowed(0);
            },
        },
        {
            label: 'Фінансові дані',
            icon: 'pi pi-money-bill',
            command: () => {
                setTabShowed(1);
            },
        },
        ...(location.state.id !== undefined
            ? [
                {
                    label: 'Історія',
                    icon: 'pi pi-history',
                    command: () => {
                        setTabShowed(2);
                        getCagentHistory(location.state.id, historyLazyState);
                    },
                },
            ]
            : []),
    ];

    useEffect(() => {
        if (location.state.id !== undefined) {

            const fetchData = async () => {

                setIsEdit(true);

                const response = await fetchCagentDetails(location.state.id);

                if (response.status === 200) {
                    if (response.data.individual_cagent_data) {
                        response.data.individual_cagent_data.date_of_birth = new Date(response.data.individual_cagent_data.date_of_birth);

                        response.data.legal_cagent_data =
                        {
                            long_name: "",
                            short_name: "",
                            representative: "",
                            edrpou: ""
                        }
                    }
                    else {
                        response.data.individual_cagent_data = {
                            first_name: "",
                            last_name: "",
                            surname: "",
                            date_of_birth: null
                        }
                    }

                    console.log(response.data);

                    setCagentData(response.data);
                }
            }

            fetchData();
        }
    }, [location.state, fetchCagentDetails]);

    const getCagentHistory = async (id, state) => {

        const response = await fetchCagentHistory(id, state);

        console.log(response);

        if (response.status === 200) {
            setCagentHistory(response.data.results);
            setHistoryTotalRecords(response.data.count);
        }
        else {
            toast.current.show({ severity: "error", summary: "Помилка отримання історії", detail: "Помилка сервера " + response.status, life: 3000 });
        }
    }

    const onHistoryPage = (event) => {
        event.page = event.page + 1;
        getCagentHistory(location.state.id, event);

        setHistoryLazyState(event);
    }

    const formik = useFormik({
        initialValues: cagentData,
        enableReinitialize: true,
        validate: values => {
            const errors = {};

            if (values.type === "INDIVIDUAL") {

                if (values.individual_cagent_data?.last_name === null || values.individual_cagent_data?.last_name === "") {
                    errors.last_name = "Прізвище контрагента не повинне бути пустим";
                }

                if (values.individual_cagent_data?.first_name === null || values.individual_cagent_data?.first_name === "") {
                    errors.first_name = "Імя контрагента не повинне бути пустим";
                }

            }
            else {

                if (values.legal_cagent_data?.long_name === null || values.legal_cagent_data?.long_name === "") {
                    errors.long_name = "Повна назва організації не повинна бути пустою";
                }

                if (values.legal_cagent_data?.short_name && values.legal_cagent_data?.short_name.length > 50) {
                    errors.short_name = "Коротка назва не повинна перевищувати 50 символів";
                }
            }

            if (values.division === null) {
                errors.division = "Точка продажу не повина бути пустою"
            }

            if (values.country === null || values.country === undefined) {
                errors.country = "Виберіть будь ласка країну"
            }

            if (values.region === null || values.region === undefined) {
                errors.region = "Виберіть будь ласка область"
            }

            if (values.city === null || values.city === "") {
                errors.city = "Населений пункт не повинен бути пустим"
            }

            if (!values.is_partner && !values.is_client) {
                errors.WrongContrAgentType = "Контрагент повинен бути клієнтом або постачальником";
            }

            values.cagent_financial_data.forEach((item, index) => {
                if (!item.data_type) {
                    if (!errors.cagent_financial_data) {
                        errors.cagent_financial_data = [];
                    }
                    errors.cagent_financial_data[index] = { data_type: "Data type is required" };
                }
            });

            return errors;
        },
        onSubmit: async (values) => {

            setSubmitLoading(true);

            const payload = values;

            if (values.type === "INDIVIDUAL") {
                if (payload.individual_cagent_data.date_of_birth) {
                    payload.individual_cagent_data.date_of_birth = formatShortDate(values.individual_cagent_data.date_of_birth);
                }

                payload.legal_cagent_data = null;
            }
            else {
                payload.individual_cagent_data = null;
            }

            const response = isEdit ? await updateCagent(location.state.id, payload) : await createCagent(payload);

            setSubmitLoading(false);

            const successStatus = isEdit ? 200 : 201;

            if (response.status === successStatus) {
                const toastMessage = isEdit ? { severity: "success", summary: "Успіх редагування", detail: "Контрагент успішно відредагований", life: 3000 } :
                    { severity: "success", summary: "Успіх створення", detail: "Контрагент успішно створений", life: 3000 }

                const endpoint = location.state.isClient ? "/clients" : "/partners";
                navigate(endpoint, { state: { toast: toastMessage } });
            }
            else {
                DisplayErrors(response.error, toast);
            }
        }
    });

    const AddIBANButtonHandler = () => {
        const data = [...formik.values.cagent_financial_data,
        {
            data_type: "IBAN",
            iban_number: "",
            mfo: "",
            bank_name: "",
            card_number: "",
            description: "",
        }
        ];

        formik.setFieldValue('cagent_financial_data', data);
    }

    const AddCardButtonHandler = () => {
        const data = [...formik.values.cagent_financial_data,
        {
            data_type: "CARD",
            iban_number: "",
            mfo: "",
            bank_name: "",
            card_number: "",
            description: "",
        }
        ];

        formik.setFieldValue('cagent_financial_data', data);
    }

    const confirmLeave = (event) => {

        if (formik.values !== cagentData) {

            confirmDialog({
                group: 'headless',
                header: 'Незбережені зміни',
                message: 'У вас є незбережені зміни. Ви впевнені, що хочете залишити цю сторінку?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: "Так",
                rejectLabel: "Hi",
                defaultFocus: 'accept',
                accept: () => { navigate(location.state.isClient ? "/clients" : "/partners", { state: { pageState: location.state?.pageState } }) }
            });

        }
        else {
            navigate(location.state.isClient ? "/clients" : "/partners", { state: { pageState: location.state?.pageState } });
        }
    }

    const toolbarLeftData = () => {
        return !isMobile ? (isEdit ? <h3>Редагування контрагента</h3> : <h3>Створення нового контрагента</h3>) : null;
    }

    console.log(formik.errors);

    return (<form onSubmit={formik.handleSubmit}>
        <Toast ref={toast} />
        <CommonToolbar isMobile={isMobile} isFinalized={false} loading={submitLoading} onRetunButtonClick={(event) => confirmLeave(event)} leftContent={toolbarLeftData()} />
        <ConfirmDialog group="headless" />
        <div className="grid nested-grid">
            <div className={`${commonStyle.leftMenu} col-3`}>
                <DropdownInput
                    formik={formik}
                    paramName={"division"}
                    context={ctx.enums.divisions.data}
                    onChange={(val) => formik.setFieldValue("division", val)}
                    label={"Точка продажу"}
                    isMobile={isMobile}
                    mandatory />
                <RadioButtonInput
                    value={formik.values.type}
                    onChange={(val) => formik.setFieldValue("type", val)}
                    options={[
                        { value: "INDIVIDUAL", label: "Фізична особа" },
                        { value: "LEGAL", label: "Юридична особа" },
                    ]}
                />
                {formik.values.type === "INDIVIDUAL" && (<>
                    <TextInput formik={formik} paramName="individual_cagent_data.last_name" label="Прізвище контрагента" mandatory />
                    <TextInput formik={formik} paramName="individual_cagent_data.first_name" label="Ім'я контрагента" mandatory />
                    <TextInput formik={formik} paramName="individual_cagent_data.surname" label="По-батькові контрагента" />
                    <CalendarInput formik={formik} paramName="individual_cagent_data.date_of_birth" label="Дата народження" />
                </>)}
                {formik.values.type === "LEGAL" && (<>
                    <TextInput formik={formik} paramName="legal_cagent_data.long_name" label="Повна назва контрагента" mandatory />
                    <TextInput formik={formik} paramName="legal_cagent_data.short_name" label="Скорочена назва контрагента" />
                    <TextInput formik={formik} paramName="legal_cagent_data.representative" label="Представник" />
                    <TextInput formik={formik} paramName="legal_cagent_data.edrpou" label="ЄДРПОУ" />
                </>)}
                <TextInput formik={formik} paramName={"email"} label={"Email"} />
                <TextInput formik={formik} paramName={"phone"} label={"Телефон"} />
                <CheckboxInput formik={formik} paramName={"is_partner"} label={"Постачальник"} mainStyle={"mb-1 mt-1"} />
                <CheckboxInput formik={formik} paramName={"is_client"} label={"Клієнт"} mainStyle={"mb-1 mt-1"} />
            </div>
            <div className="col-9">
                <TabMenu model={items} />
                {tabShowed === 0 && (<><div className="grid">
                    <div className="col-4">
                        <DropdownInput
                            formik={formik}
                            paramName="country"
                            context={countries}
                            onChange={(val) => formik.setFieldValue("country", val)}
                            label={"Країна"}
                            customStyle="w-11"
                            mandatory
                        />
                        <TextInput formik={formik} paramName={"street"} label={"Вулиця"} customStyle="w-11" />
                    </div>
                    <div className="col-4">
                        <DropdownInput
                            formik={formik}
                            paramName={"region"}
                            context={regions}
                            onChange={(val) => formik.setFieldValue("region", val)}
                            label={"Область"}
                            customStyle="w-11"
                            mandatory />
                        <TextInput formik={formik} paramName={"building_number"} label={"Номер будинку"} customStyle="w-11" />
                    </div>
                    <div className="col-4">
                        <TextInput formik={formik} paramName={"city"} label={"Місто"} customStyle="w-11" mandatory />
                        <TextInput formik={formik} paramName={"apartment_number"} label={"Квартира"} customStyle="w-11" />
                    </div>
                </div>
                    <div className={`${commonStyle.inputfields} p-inputgroup col-8`}>
                        <span className="p-float-label md:w-90">
                            <InputTextarea value={formik.values.description} onChange={(e) => { formik.setFieldValue('description', e.target.value) }} rows={10} cols={80} />
                            <label>Примітки</label>
                        </span>
                    </div>
                </>)}
                {tabShowed === 1 && (<>
                    {(formik.values.cagent_financial_data.map((finData, index) => (
                        <div className="grid" key={index}>
                            <div className="col-4">
                                {finData.data_type === "IBAN" && <div className={`${commonStyle.inputfields} flex-column p-inputgroup`}>
                                    <FloatLabel>
                                        <InputText value={finData.iban_number || ""}
                                            onChange={(e) => formik.setFieldValue(`cagent_financial_data[${index}].iban_number`, e.target.value)} />
                                        <label>Номер IBAN</label>
                                    </FloatLabel>
                                </div>}
                                {finData.data_type === "CARD" && <div className={`${commonStyle.inputfields} flex-column p-inputgroup`}>
                                    <FloatLabel>
                                        <InputText value={finData.card_number || ""}
                                            onChange={(e) => { formik.setFieldValue(`cagent_financial_data[${index}].card_number`, e.target.value) }} />
                                        <label>Номер картки</label>
                                    </FloatLabel>
                                </div>}
                            </div>
                            <div className="col-4">
                                {finData.data_type === "IBAN" && <div className={`${commonStyle.inputfields} flex-column p-inputgroup`}>
                                    <FloatLabel>
                                        <InputText value={finData.bank_name || ""}
                                            onChange={(e) => { formik.setFieldValue(`cagent_financial_data[${index}].bank_name`, e.target.value) }} />
                                        <label>Назва банку</label>
                                    </FloatLabel>
                                </div>}
                            </div>
                            <div className="col-3">
                                {finData.data_type === "IBAN" && <div className={`${commonStyle.inputfields} flex-column p-inputgroup`}>
                                    <FloatLabel>
                                        <InputText value={finData.mfo || ""}
                                            onChange={(e) => { formik.setFieldValue(`cagent_financial_data[${index}].mfo`, e.target.value) }} />
                                        <label>МФО</label>
                                    </FloatLabel>
                                </div>}
                            </div>
                            <div className="col-1">
                                <Button
                                    icon="pi pi-trash"
                                    className={`p-button-rounded p-button-danger ${commonStyle.deleteButton}`}
                                    style={{ marginTop: "2rem" }}
                                    tooltip="Видалити"
                                    tooltipOptions={{ showOnDisabled: true }}
                                    type="button"
                                    onClick={() => {
                                        const newArray = formik.values.cagent_financial_data.filter((_, i) => i !== index);
                                        formik.setFieldValue('cagent_financial_data', newArray);
                                    }}
                                />
                            </div>
                        </div>
                    )))}
                    <div className="col-12">
                        <Button icon="pi pi-credit-card" label="Додати картку" severity="success" className={`${commonStyle.addButton} ${commonStyle.addButtonNav}`} onClick={AddCardButtonHandler} type="button" />
                        <Button icon="pi pi-money-bill" label="Додати рахунок" severity="success" className={commonStyle.addButton} onClick={AddIBANButtonHandler} type="button" />
                    </div>
                    <div className={`${commonStyle.inputfields} p-inputgroup col-8`}>
                        <span className="p-float-label md:w-90">
                            <InputTextarea value={formik.values.cagent_financial_data.description} onChange={(e) => { formik.setFieldValue('cagent_financial_data.description', e.target.value) }} rows={10} cols={80} />
                            <label>Примітки</label>
                        </span>
                    </div>
                </>)}
                {tabShowed === 2 && <HistoryElement data={cagentHistory} lazyState={historyLazyState} totalRecords={historyTotalRecords} onHistoryPage={onHistoryPage} isAct={false} />}
            </div>
        </div>
    </form>
    );
}

export default NewCounterAgent;